<template>
  <div class="p-px-3 p-pb-3">
    <h1>{{ isAdmin ? `${company.companyname} - `: '' }}Nytt prosjekt</h1>
    <div class="p-fluid">
        <div class="p-field">
            <label for="projectname" class="mandatory">Prosjektnavn</label>
            <InputText id="projectname" type="text" placeholder='Beskrivende prosjektnavn' v-model="newProject.projectname" />
        </div>
        <div class="p-field">
            <label for="address" class="mandatory">Leveringsadresse</label>
            <InputText id="address" type="text" v-model='newProject.address' placeholder='f.eks. Åsmarkvegen 301' />
        </div>
        <div class="p-field">
            <label for="postalcode" class="mandatory">Postnummer</label>
            <InputNumber id="postalcode" v-model='newProject.postalcode' :maxlength='4' :useGrouping="false"/> 
        </div>
        <div class="p-field">
            <label for="postalplace" class="mandatory">Poststed</label>
            <InputText id="postalplace" type="text" v-model='newProject.postalplace' placeholder='f.eks. Lillehammer' />
        </div>
        <div class="p-field">
            <label for="comment">Evt. kommentar</label>
            <InputText id="comment" type="text" v-model='newProject.comment' placeholder='Kommentar' />
        </div>
        <div class="p-field">
            <label for="farmnumber">Evt. gårdsnr</label>
            <InputNumber id="farmnumber" v-model='newProject.farmnumber' :useGrouping="false" />
        </div>
        <div class="p-field">
            <label for="usagenumber">Evt. bruksnr</label>
            <InputNumber id="usagenumber" v-model='newProject.usagenumber' :useGrouping="false" />
        </div>
    </div>
    <div v-if="isAdmin">
      <Divider class="p-my-6" />
      <h3 class="mandatory">Sett eier av prosjektet</h3>
      <DataTable
        v-if="employees"
        :value="employees"
        :selection.sync="selected" 
        :filters="filters"
      >
        <Column selectionMode="single" headerStyle="width: 3em"></Column>
        <Column field="name" header="Navn" filterMatchMode="contains">
          <template #filter>
            <InputText 
              type="text" 
              v-model="filters['name']" 
              class="p-column-filter" 
              placeholder="Søk på navn"
            ></InputText>
          </template>
        </Column>
        
        <Column field="Email" header="E-post" filterMatchMode="contains">
          <template #body="slotProps">
                <p>
                  <a :href="`mailto:${slotProps.data.Email}`">{{ slotProps.data.Email }}</a>
                </p> 
          </template>
          <template #filter>
            <InputText 
              type="text" 
              v-model="filters['Email']" 
              class="p-column-filter" 
              placeholder="Søk på E-post"
            ></InputText>
          </template>
        </Column>
      </DataTable>
    </div>
    <div v-show="errors.length">
      <Message v-for="(error, index) in errors" :key="index" severity="error">{{error}}</Message>
    </div>
    
    <div class="p-mt-4 p-d-flex p-jc-end">
      <Button label="Lagre" @click="validate()"/>
    </div>
  </div>
</template>

<script>
import Message from 'primevue/message';
import Divider from 'primevue/divider';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';

export default {
name: 'projectAdd',

components: {
  InputNumber,
  Message,
  DataTable,
  Column,
  Divider
},

data(){
  return{
    errors: [],
    filters: {},
    selected: null,
    newProject: {
      active: true,
      address: '',
      comment: '',
      enddate: new Date(),
      farmnumber: null,
      lat: 0,
      lon: 0,
      owner: null,
      postalcode: null,
      postalplace: '', 
      projectname: '',
      startdate: new Date(),
      usagenumber: null,
      useraccess: [],
      createdbyadmin: false,
      createddate: new Date()
    }
  }
},

mounted(){
  this.$store.dispatch('employees/inspect', {id: this.company.organizationnumber, type: 'company'})
},

methods: {
  save(){
    var ownerId = this.newProject.owner ? this.newProject.owner : this.user.id
    this.$store.dispatch('projects/add', {
      ...this.newProject,
      ...{owner: ownerId},
      ...{createdbyadmin: this.isAdmin}, 
      ...{useraccess: [ownerId]},
      ...{companyID: this.company.organizationnumber}
      })
    .then((project) => {
      this.$store.dispatch('projects/inspect', {id: this.user.id, type: 'user'}).then(() => {
        this.$router.push({name: 'project', params: {id: project.id}})
      })
    })
  },
  validate() {
    this.errors = []
    if(this.newProject.projectname.length == 0 ) { this.errors.push('Prosjektnavn påkrevd')}
    if(this.newProject.address.length == 0 ) { this.errors.push('Adresse påkrevd')}
    if(!this.newProject.postalcode || this.newProject.postalcode.toString().length != 4 ) { this.errors.push('Postnummer, 4 siffer påkrevd')}
    if(!this.newProject.postalplace || this.newProject.postalplace.length == 0 ) { this.errors.push('Poststed påkrevd')}
    
    if(this.isAdmin){
      if(!this.selected) { this.errors.push('Sett en eier av prosjektet')}
      else this.newProject.owner = this.selected.id
    }  
    this.$db.collection('projects').where('projectname', '==', this.newProject.projectname).get().then(projects => {
      if(projects.size){
        projects.forEach(project => {
          project.data().useraccess.forEach(userId => {
            if(this.employeesIds.includes(userId)){
              this.errors.push('Et prosjekt med dette navnet finnes allerede i bedriften')
              return false; 
            }
          })
        })
      }
        
      
      if(this.errors.length  > 0)
        return false
      
      this.save()
    })
    
  },
},

computed: {
  employeesIds(){
    return this.$store.getters['employees/inspect'].map(item => item = item.id)
  },
  company(){
    return this.$store.getters['companies/current']
  },
  user(){
    return this.$store.getters['user/get']
  },
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }, 
  employees(){
    return this.$store.getters['employees/inspect']
  }
}
}
</script>

<style lang="sass">
.p-selection-column
  width: 3em
</style>